import GenericTrackingService from "./generic_tracking_service"
import {PictureTextType} from "./types";
import PictureTextElementTile from "./picture_text_element_tile";

export default class PictureTextGrid {
    readonly featureOrder: number;
    readonly filledSlots: number;
    readonly featureIndex: number;
    readonly featureId: string;
    readonly parentFeatureId: string;
    readonly masFeatureTrackingLabels: { [key: string]: string[] } = {};

    readonly trackingWidgetTiles: PictureTextElementTile[] = [];
    private readonly trackingService: GenericTrackingService;

    constructor() {
        const container: HTMLElement | null = document.querySelector('.promo_staticcontent--picture-text-grid-widget');
        if (!container) {
            throw new Error("PictureTextGrid DOM element not found");
        }

        this.featureOrder = this.getFeatureOrder(container);
        this.featureIndex = this.getFeatureIndex(container);
        this.featureId = this.getDataFeatureId(container)
        this.masFeatureTrackingLabels = this._getMasFeatureTrackingLabels(container);
        this.parentFeatureId = this.getParentFeatureTrackingId(this.featureId);
        const pictureTextGridTiles = Array.from(container.querySelectorAll<HTMLElement>('[data-js="picture-text-grid-tile"]'));
        this.trackingWidgetTiles = pictureTextGridTiles
            .map((tileDom: HTMLElement, index: number) => new PictureTextElementTile(tileDom, index + 1, this.getTileFeatureTrackingId(this.featureId, index + 1)))

        this.filledSlots = this.trackingWidgetTiles.length;
        this.trackingService = new GenericTrackingService();
        this.trackLoaded(container);
        this.registerScrollTrackingObserver(pictureTextGridTiles);


        pictureTextGridTiles.forEach((bildTextTileDom: HTMLElement, index: number) => {
            bildTextTileDom.addEventListener("click", this.trackClick(this.trackingWidgetTiles[index], "Grid"), false);
        });
    }

    trackClick(trackingWidgetTile: PictureTextElementTile, tileType: PictureTextType): () => void {
        const self = this;
        return function () {
            self.trackingService.sendClickTrackingEvent(self.featureOrder, self.featureIndex, self.parentFeatureId, trackingWidgetTile, self.filledSlots, self.masFeatureTrackingLabels, tileType);
        }
    }

    registerScrollTrackingObserver(pictureTextTileDoms: HTMLElement[]): void {
        /*                                     */
        const trackingObserver = new IntersectionObserver((entries) => {
            const entriesToTrack = entries
                .filter((entry) => entry.isIntersecting);

            if (entriesToTrack.length > 0) {
                const positionsToTrack = entriesToTrack
                    .map((entry) => this.getTileFeatureTrackingId(this.featureId, parseInt(entry.target.getAttribute("data-tile-position")!)))

                this.trackingService.sendScrollTrackingEvent(this.parentFeatureId, positionsToTrack);

                entriesToTrack.forEach((entry) => {
                    trackingObserver.unobserve(entry.target);
                });
            }

        });
        pictureTextTileDoms.forEach((card) => {
            trackingObserver.observe(card);
        });
    }

    private getFeatureOrder(container: Element): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    private getFeatureIndex(container: Element): number {
        return parseInt(container.getAttribute('data-feature-index')!, 0);
    }

    private getDataFeatureId(container: Element): string {
        return container.getAttribute('data-feature-id')!;
    }

    _getMasFeatureTrackingLabels(container: Element) {
        const dataFeatureTrackingLabels = container.closest('[data-feature-tracking-labels]')?.getAttribute("data-feature-tracking-labels");
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    private trackLoaded(container: Element) {
        if (!container.getAttribute("data-tracked")) {
            container.setAttribute("data-tracked", "true");
            this.trackingService.sendLoadedTracking(
                this.featureOrder,
                this.featureIndex,
                this.parentFeatureId,
                this.trackingWidgetTiles,
                this.masFeatureTrackingLabels,
                "Grid");
        }
    }

    private getParentFeatureTrackingId(featureId: string) {
        return `ft3_ptg_${featureId}`;
    }

    private getTileFeatureTrackingId(featureId: string, tilePosition: number) {
        return `ft3_ptg_${featureId}_tile${tilePosition}`;
    }
}